export const useMaterialFavoriteListsConnectedToFitterStore = defineStore('materialFavoriteListsConnectedToFitter', () => {
  const catalogAPI = useCatalogAPI();
  const settingsStore = useSettingsStore();

  const favoriteLists = ref<FavoriteListInfoDTO[]>([]);
  const favoriteListItems = ref<FavoriteListItemApp>();
  const defaultFavoriteLists = ref<FavoriteListInfoDTO[]>([]);
  const isPersonal = ref<boolean>(false);

  async function setMaterialFavoriteListsConnectedToFitter() {
    const response = await catalogAPI.GetMaterialFavoriteListsInfoConnectedToFitter();

    if (response && !response.HasErrors) {
      const savedOrder = settingsStore._settings.favoriteListIds;
      const fetchedLists: FavoriteListInfoDTO[] = response.Data;

      const fetchedMap = new Map<number, FavoriteListInfoDTO>(
        fetchedLists.map(item => [item.ListId, item])
      );

      const orderedFromSaved: FavoriteListInfoDTO[] = savedOrder
        .map(id => fetchedMap.get(id))
        .filter((item): item is FavoriteListInfoDTO => !!item);

      const remaining = fetchedLists.filter(item => !savedOrder.includes(item.ListId));

      const ordered = [...orderedFromSaved, ...remaining];

      favoriteLists.value = ordered;
      defaultFavoriteLists.value = [...ordered];
    }
  }

  function resetFavoriteListsToDefault() {
    favoriteLists.value = [...defaultFavoriteLists.value];
  }

  function setDefaultFavoriteListsFromCurrent() {
    defaultFavoriteLists.value = [...favoriteLists.value];
  }

  async function getMaterialFavoriteListItems(request: MaterialFavoriteListAppRequestDTO, isPersonalList: boolean, append: boolean = false) {
    const includeImages = settingsStore._settings.showWholesalerCatalogItemImages;
    const response = await catalogAPI.GetMaterialItemsForFavoriteListApp(request, isPersonalList, includeImages);
    isPersonal.value = isPersonalList;
    
    if (response && !response.HasErrors) {
      if (append) {
        if (favoriteListItems.value) {
          favoriteListItems.value.Items = [...favoriteListItems.value.Items, ...response.Data.Items];
          favoriteListItems.value.FinalPage = response.Data.FinalPage;
        }
      } else {
        favoriteListItems.value = response.Data;
      }

      return favoriteListItems.value?.Items ?? [];
    }

    return [];
  }

  return {
    setMaterialFavoriteListsConnectedToFitter,
    getMaterialFavoriteListItems,
    resetFavoriteListsToDefault,
    setDefaultFavoriteListsFromCurrent,
    defaultFavoriteLists,
    favoriteLists,
    favoriteListItems,
    isPersonal
  };
});
